export default __webpack_public_path__ + "static/devrel-seed-grow-grow-more-diagram-64b2f7695c58dae6fa9bac8fc0cac5b2.png";